import { useMemo } from "react";
import { useIntl } from "react-intl";
import { formatOccurrenceStepLabel, formatOccurrenceStepLabelByLabel } from "../enums/occurrenceStep";

export interface OccurrenceStep {
  step?: string;
  name?: string;
  dtStart?: Date | null | undefined;
  dtEnd?: Date | null | undefined;
  estimatedTime?: string | null;
  logs?: {
    startDate?: Date | null | undefined;
    endDate?: Date | null | undefined;
  }[];
}

interface CurrentStepResult {
  label: string;
  isInProgress: boolean;
}

/**
 * Hook para calcular a etapa atual de uma ocorrência.
 */
export function useCurrentStep(steps: OccurrenceStep[] = []): CurrentStepResult | null {
  const intl = useIntl();
  return useMemo(() => {
    if (!steps.length) return null;

    const inProgress = steps.find(s => s.dtStart && !s.dtEnd);

    if (inProgress) {
      return {
        label: formatOccurrenceStepLabel(intl, inProgress.step || "") || (inProgress.name ? formatOccurrenceStepLabelByLabel(intl, inProgress.name) : "") || intl.formatMessage({ id: "intl-msg:kanban.charts.currentStep" }),
        isInProgress: true,
      };
    }

    return null;
  }, [steps, intl]);
}
